/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { Button } from '@mui/material';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useProductSamplingContext from '../context/useProductSamplingContext';

function Table() {
  //
  const {
    auth,
    activeTab,
    productsData,
    loading,
    handleViewProduct,
    handleAddProductModal,
    handleAddProduct,
  } = useContext(useProductSamplingContext);

  const columns = [
    { field: 'product_name', flex: 1, headerName: 'Product Name', width: 200 },
    { field: 'visible_segments', flex: 1, headerName: 'Visible to', width: 200 },
    {
      field: 'is_published',
      flex: 1,
      headerName: 'Status',
      width: 200,
      renderCell: ({ row }) =>
        row.is_published === 1 ? (
          <Chip label='Published' color='success' />
        ) : (
          <Chip label='Not Published' />
        ),
    },
    {
      field: 'action',
      flex: 1,
      headerName: 'Action',
      width: 200,
      renderCell: ({ row }) => (
        <div>
          <Button
            size='small'
            variant='contained'
            color='primary'
            onClick={(e) => handleViewProduct(row.product_code)}
            startIcon={<EditNoteOutlinedIcon />}
          >
            Update
          </Button>
        </div>
      ),
    },
  ];
  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ float: 'right' }}
          onClick={(e) => handleAddProductModal()}
          startIcon={<AddOutlinedIcon />}
        >
          Add New Product(S)
        </Button>
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          <DataGridPro rows={productsData} columns={columns} loading={loading} />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
